import { render, staticRenderFns } from "./PreviewInvoice.vue?vue&type=template&id=3c954715&scoped=true"
import script from "./PreviewInvoice.vue?vue&type=script&lang=js"
export * from "./PreviewInvoice.vue?vue&type=script&lang=js"
import style0 from "./PreviewInvoice.vue?vue&type=style&index=0&id=3c954715&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c954715",
  null
  
)

export default component.exports